// src/data/data.js

export const heroData = {
    title: "Unleash Your Potential",
    subtitle: "Join the best gym in town and get fit today!",
    buttonText: "Join Now"
  };
  
  export const services = [
    { id: 1, title: "Personal Training", description: "1-on-1 training with expert coaches." },
    { id: 2, title: "Cardio Programs", description: "Burn calories with our intense cardio sessions." },
    { id: 3, title: "Strength Training", description: "Build muscle and gain strength with tailored programs." },
  ];
  
  export const plans = [
    { id: 1, name: "Basic", price: "$20/mo", features: ["Gym Access", "1 Trainer Session"] },
    { id: 2, name: "Standard", price: "$40/mo", features: ["All Basic Features", "Group Classes"] },
    { id: 3, name: "Premium", price: "$60/mo", features: ["All Standard Features", "Unlimited Sessions"] },
  ];
  
  export const contact = {
    phone: "+1234567890",
    email: "info@gymfit.com",
    address: "123 Fitness Ave, Workout City"
  };
  